import React from 'react';
import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import info from "../../../assets/images/new/info.svg";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "350px",  // Set max-width to 350px here
    width: "350px",     // Fix width to 350px
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const StableTooltip = React.memo(({ description }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if (!description) return null;

  return (
    <CustomTooltip
      title={description}
      arrow
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      enterDelay={200}
      leaveDelay={100}
      disableInteractive
    >
      <img
        src={info}
        alt="category information"
        width={16}
        height={16}
        className="ml-10 cursor-p mt-3"
      />
    </CustomTooltip>
  );
});

export default StableTooltip;
